import React from 'react';
import { Feature as ProductFeature } from '../../../../Stars';
export var Feature = function Feature(_ref) {
  var value = _ref.value;
  var score = value.score;
  return React.createElement(ProductFeature, {
    value: score
  });
};